// 図形をドラッグで配置している最中のプレビュー（ゴースト）枠。
// ステージ座標で配置するため、親のステージ（pan/zoom transform 配下）に置くことで
// pan/zoom に追従して正しい位置・サイズで表示される。確定済みの図形と同じ ShapeGlyph を
// 使って描画するため、ドロップ後の最終的な見た目と一致する。枠自体はヒットを取らない
// （pointerEvents: none）ので、ドラッグ中のポインタ処理を邪魔しない。

import { useCanvasStore } from "./store/canvas-store";
import { ShapeGlyph } from "./objects/shape-object";
import { SHAPE_FILL_NONE } from "../../lib/shape-preference";

export function CanvasShapePlacementOverlay(): JSX.Element | null {
  const draft = useCanvasStore((s) => s.shapePlacementDraft);
  const shapeKind = useCanvasStore((s) => s.shapeKind);
  const shapeFill = useCanvasStore((s) => s.shapeFill);
  if (!draft) return null;
  // 背景なしのときは transparent で描画する（確定オブジェクトの fill 未設定と同じ見た目）。
  const fill = shapeFill === SHAPE_FILL_NONE ? "transparent" : shapeFill;
  return (
    <svg
      data-testid="canvas-shape-placement-preview"
      style={{
        position: "absolute",
        left: `${draft.x}px`,
        top: `${draft.y}px`,
        width: `${draft.w}px`,
        height: `${draft.h}px`,
        pointerEvents: "none",
        overflow: "visible",
        zIndex: Number.MAX_SAFE_INTEGER,
      }}
      viewBox={`0 0 ${draft.w} ${draft.h}`}
      preserveAspectRatio="none"
    >
      <ShapeGlyph
        shapeKind={shapeKind}
        w={draft.w}
        h={draft.h}
        fill={fill}
        stroke="var(--color-accent)"
        strokeWidth={2}
        arrowFromCorner={draft.arrowFromCorner}
        pointerEvents="none"
      />
    </svg>
  );
}
